import {
  OPEN_SHOPPING_LISTS_MODAL,
  OPEN_SHOPPING_LISTS_MODAL_FROM_BASKET,
  CLOSE_SHOPPING_LISTS_MODAL,
  OPEN_SHOPPING_LISTS_FORM,
  CLOSE_SHOPPING_LISTS_FORM,
  ADD_SHOPPING_LIST,
  ADD_TO_SHOPPING_LIST,
  UPDATE_NEW_SHOPPING_LIST_FIELD,
  REMOVE_FROM_SHOPPING_LIST,
  RECEIVE_SHOPPING_LISTS,
  REQUEST_SHOPPING_LISTS,
} from '../actions/shoppingLists';

export const initialState = {
  product: null,
  items: [],
  error: null,
  modal: false,
  addNew: false,
  newShoppingList: '',
  pending: false,
};

const ACTIONS = {
  [OPEN_SHOPPING_LISTS_MODAL]: ({ state, action }) =>
    ({ ...state, modal: true, fromBasket: false, product: action.product }),
  [OPEN_SHOPPING_LISTS_MODAL_FROM_BASKET]: ({ state }) => ({ ...state, modal: true, fromBasket: true, product: null }),
  [CLOSE_SHOPPING_LISTS_MODAL]: ({ state }) => ({ ...state, modal: false, fromBasket: null, product: null }),
  [OPEN_SHOPPING_LISTS_FORM]: ({ state }) => ({ ...state, addNew: true }),
  [CLOSE_SHOPPING_LISTS_FORM]: ({ state }) => ({ ...state, addNew: false }),
  [ADD_SHOPPING_LIST]: ({ state, action }) =>
    ({ ...state, items: [...state.items, { listId: action.id, listName: action.name, containsSku: false }] }),
  [ADD_TO_SHOPPING_LIST]: ({ state, action }) => {
    const items = state.items.map((item) => {
      if (item.listId === action.shoppingListId) {
        return { ...item, containsSku: true };
      }
      return item;
    });
    return { ...state, items };
  },
  [REMOVE_FROM_SHOPPING_LIST]: ({ state, action }) => {
    const items = state.items.map((item) => {
      if (item.listId === action.shoppingListId) {
        return { ...item, containsSku: false };
      }
      return item;
    });
    return { ...state, items };
  },
  [REQUEST_SHOPPING_LISTS]: ({ state }) => ({ ...state, pending: true }),
  [RECEIVE_SHOPPING_LISTS]: ({ state, action }) => ({ ...state, items: action.items, pending: false }),
  [UPDATE_NEW_SHOPPING_LIST_FIELD]: ({ state, action }) => ({ ...state, newShoppingList: action.newShoppingList }),
};

export default function shoppingLists(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
